document.addEventListener("DOMContentLoaded", function() {

	// responzivní menu
	// ================

	/*let submenu = document.querySelector('.JS-submenu'),
		closemenu = document.querySelector('.JS-close-menu'),
		toggle = document.querySelector('.toggleMenu');


	if (typeof(toggle) != 'undefined' && toggle != null) {
		toggle.onclick = function (e) {
			e.preventDefault();
			this.classList.toggle('active');
			document.querySelector('.JS-menu-obal--inner').classList.toggle('active');
			document.querySelector('body').classList.toggle('no-scrollbar');
		};
	}

	if (typeof(submenu) != 'undefined' && submenu != null) {
		submenu.onclick = function (e) {
			this.classList.toggle('active');
			this.nextElementSibling.classList.toggle('active');
		};
	}

	if (typeof(closemenu) != 'undefined' && closemenu != null) {
		closemenu.onclick = function (e) {
			console.log("zavri");
			this.classList.remove('active');
			document.querySelector('.JS-menu-obal--inner').classList.remove('active');
			document.querySelector('body').classList.remove('no-scrollbar');
		};
	}*/
});